import jsCookie from "js-cookie";
import UrlHelper from "./UrlHelper";
import * as Constants from "./Constants";

class CookieManager{
    constructor() {
        jsCookie.defaults = { secure: true };
    }

    getSiteIdForLoginPage() {
        return jsCookie.get(Constants.COOKIE_NAME_REMEMBER_ME);
    }

    setSiteIdForLoginPage(value) {
        jsCookie.set(Constants.COOKIE_NAME_REMEMBER_ME, value, { expires: Constants.REMEMEBER_SITEID_EXPIRATION_DAYS, domain: UrlHelper.getDomain() });
    }

    removeSiteIdForLoginPage() {
        jsCookie.remove(Constants.COOKIE_NAME_REMEMBER_ME, { domain: UrlHelper.getDomain() });
    }

    getEmailForLoginPage() {
        return jsCookie.get(Constants.COOKIE_NAME_REMEMBER_EMAIL);
    }

    setEmailForLoginPage(value) {
        jsCookie.set(Constants.COOKIE_NAME_REMEMBER_EMAIL, value, { expires: Constants.REMEMEBER_EMAIL_EXPIRATION_DAYS, domain: UrlHelper.getDomain() });
    }

    removeEmailForLoginPage() {
        jsCookie.remove(Constants.COOKIE_NAME_REMEMBER_EMAIL, { domain: UrlHelper.getDomain() });
    }


    setSsoSiteId(value) {
        jsCookie.set(Constants.COOKIE_NAME_SITEID_SSO, value, { domain: UrlHelper.getDomain() });
    }

    removeSsoSiteId() {
        jsCookie.remove(Constants.COOKIE_NAME_SITEID_SSO, { domain: UrlHelper.getDomain() });
    }

    getSsoSiteId() {
        var cookie = jsCookie.get(Constants.COOKIE_NAME_SITEID_SSO);
        return cookie ? cookie : "";
    }

    setEmailLogin(value) {
        jsCookie.set(Constants.COOKIE_NAME_EMAIL_LOGIN, value, { domain: UrlHelper.getDomain() });
    }

    getUnsupportedBrowsersCookie() {
        return jsCookie.get(Constants.COOKIE_NAME_UNSUPPORTED_BROWSER);
    }

    setUnsupportedBrowsersCookieSuppressValue(isRemindMeLater, dontShowMeAgain) {
        if (isRemindMeLater) {
            // remind me in 7 days
            var suppresPeriod = 7;
            if (dontShowMeAgain) {
                // 5 years is approximatelly equal never :)
                suppresPeriod = 1825; // = 365 * 5;
            }
            jsCookie.set(Constants.COOKIE_NAME_UNSUPPORTED_BROWSER, Constants.COOKIE_VALUE_SUPPRESS, { domain: UrlHelper.getDomain(), expires: suppresPeriod });
        }
        else
        {
            // if user close reminder, set cookie with session lifetime
            jsCookie.set(Constants.COOKIE_NAME_UNSUPPORTED_BROWSER, Constants.COOKIE_VALUE_SUPPRESS, { domain: UrlHelper.getDomain() });
        }
    }
}

export default new CookieManager;
